let documentTitle = "Enrollment Application";
let API_BASE = "https://jayi2stkod.execute-api.us-east-1.amazonaws.com/api/";

const TEST_ORIGINS = [
  "https://devenrollment.uslegalservices.net",
  "http://localhost:8080",
];

const GTM_CONTAINER_ID = "GTM-W8S6J2NK";
const HUBSPOT_PORTAL_ID = "50322147";

if (
  window.location.origin != "https://devenrollment.uslegalservices.net" &&
  window.location.origin != "http://localhost:8080"
) {
  API_BASE = "https://vvv15k44dc.execute-api.us-east-1.amazonaws.com/api/";
}

const isTestEnvironment = () => TEST_ORIGINS.includes(window.location.origin);

const isGeneralEnrollmentUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return (params.get("opt") || "").toLowerCase() === "general";
};

export default {
  documentTitle,
  API_BASE,
  TEST_ORIGINS,
  GTM_CONTAINER_ID,
  HUBSPOT_PORTAL_ID,
  isTestEnvironment,
  isGeneralEnrollmentUrl,
};
